module.exports = __webpack_public_path__ + "m3.png";